import React from "react";
import { Link } from 'react-scroll';

export default function Home() {
  return (
    <div id="home" className="h-screen relative">
      <div className="h-full flex flex-col">
        {/* Hero — original desktop layout preserved */}
        <div className="h-3/4 flex items-center justify-center mb-8">
          {/* Desktop: basis-1/2 | Mobile: 80% width */}
          <div className="h-full w-4/5 sm:w-auto sm:basis-1/2 relative">
            <img
              className="h-full w-full sm:w-auto object-cover sm:object-contain"
              src={`${process.env.PUBLIC_URL}/images/home.jpg`}
              alt=""
            />
            {/* Text card: 30% smaller text/padding on mobile */}
            <div className="bg-white z-10 absolute top-1/2 left-1/3 -translate-y-1/2 w-full
                            px-4 py-3 sm:px-6 sm:py-5">
              <div className="mb-4 sm:mb-6">
                <span className="text-primary text-lg sm:text-2xl uppercase">Wedding and Event Planner</span>
              </div>
              <div className="flex flex-col">
                <span className="text-primary text-xs sm:text-base">you do the dreaming,</span>
                <span className="text-primary text-xs sm:text-base">we do the planning</span>
              </div>
            </div>
          </div>
        </div>
        <div className="mx-auto">
          <Link to="contact" smooth={true} offset={-75}>
            <button className="inline-flex bg-button py-4 px-8 rounded-full">
              <span className="uppercase text-primary text-xs">
                Let's plan your big day!
              </span>
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}